var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"edit",attrs:{"id":"blue-top"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"back-container"},[_c('div',{staticClass:"back",on:{"click":function($event){return _vm.goback()}}},[_c('span',[_vm._v("torna indietro")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }